import styled from 'styled-components';
import { Button } from '../Button';
import { NavLink } from 'react-router-dom';

const ErrorPage = () => {
  return (
    <Wrapper>
      <div className="container">
        <div>
          <h2>404</h2>
          <h3>Uh Oh! You're lost.</h3>
          <p>
            The page you are looking for does not exist. How you got here is a mystery. But you can click the button below to go back to the home page
          </p>
          <NavLink to={"/"}>
            <Button>
              Go Back to Home
            </Button>
          </NavLink>
        </div>
      </div>
    </Wrapper>
  )
}

const Wrapper = styled.section`
 .container{
  padding:8rem;
  text-align:center;
 }

 h2{
  font-size:10rem;
 }

 h3{
  font-size:4.2rem;
 }
 p{
  margin:2rem 0;
 }
`;

export default ErrorPage;